import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import {
  useAuthentication,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { ResourcesReport } from "./resourceReport";
import { WbsReport } from "./wbsReport";
import { TimeSheetReport } from "./timesheetReport";
import { TimeSheetByTaskReport } from "./timesheetByTaskReport";
import { DailyPlanningReport } from "./dailyPlanningReport";
import { Props } from "./types";
import styles from "./styles.scss";

function ExportsPage({ project }: Props) {
  const { t } = useTranslation();
  const { account } = useAuthentication();
  const { planzone } = useRetrieveCurrentPlanzone();

  return (
    <div className={styles.exportsPage}>
      <Helmet>
        <title>Planzone • {t("exportReportsPage.title")}</title>
        <meta name="description" content={project.description} />
      </Helmet>
      <div className={styles.main}>
        <div className={styles.col}>
          <h1 className={styles.subTitle}>
            {t("exportReportsPage.reportType.title")}
          </h1>
          <p className={styles.description}>
            {t("exportReportsPage.reportType.subTitle")}
          </p>
        </div>
        <div className={styles.list}>
          <ResourcesReport
            fileName={`${t("exportReportsPage.resourceReport.projectName")} ${
              project.name
            }`}
            author={account}
            planzone={planzone}
            project={project}
          />
        </div>
        <div className={styles.list}>
          <WbsReport
            fileName={`${t("exportReportsPage.wbsZonesReport.name")} ${
              project.name
            }`}
            author={account}
            planzone={planzone}
            project={project}
          />
        </div>
        {/* <div className={styles.list}>
          <TimeSheetReport
            fileName={`${t("exportReportsPage.timeSheetReport.name")} ${
              project.name
            }`}
            author={account}
            planzone={planzone}
            project={project}
          />
        </div>*/}
        <div className={styles.list}>
          <TimeSheetByTaskReport
            fileName={
              t("exportReportsPage.timeSheetByTaskReport.name") + project.name
            }
            author={account}
            planzone={planzone}
            project={project}
          />
        </div>
        <div className={styles.list}>
          <DailyPlanningReport
            fileName={`${t("exportReportsPage.dailyPlanningReport.name")} ${
              project.name
            }`}
            author={account}
            planzone={planzone}
            project={project}
          />
        </div>
      </div>
    </div>
  );
}

export { ExportsPage };
